<template>
  <div class="grid">
    <header>
      <TopNav/>
    </header>
    <main>
      <div class="container is-fluid is-mobile">
        <section class="section">
          <h1 class="title is-4 is-size-3-tablet is-size-2-desktop">
            <span class="icon is-left is-large">
              <i class="fas fa-dungeon"></i>
            </span>
            <span>{{ $route.params.name }}</span>
          </h1>
        </section>
        <!-- <vue-page-transition name="fade-in-up"> -->
          <router-view/>
        <!-- </vue-page-transition> -->
      </div>
    </main>
    <footer>
      <InfoFooter/>
    </footer>
  </div>
</template>
<script>
import TopNav from '../components/TopNav.vue'
import InfoFooter from '../components/InfoFooter.vue'
export default {
  name: 'Campaign',
  props: {
    id: String,
    name: String,
    slug: String
  },
  data () {
    return {
    }
  },
  components: {
    TopNav,
    InfoFooter
  }
}
</script>
<style scoped>
.party {
  background-color: white;
}
.party:not(:last-child) {
  margin-bottom: 1.5em;
}
/* .icon {
  color: #ccc;
} */
/* @media (max-width: 900px) and (orientation: landscape) {
  .title {
    display: none;
  }
} */
</style>


// WEBPACK FOOTER //
// src/views/Campaign.vue